import { createSelector } from "reselect";

export const getReading = (state, id) => state.feeny.readings.byId[id];

export const getAssignment = (state, id) => {
  const assignment = state.feeny.assignments.byId[id];
  return {
    ...assignment,
    readings: assignment.readings.map(id => getReading(state, id))
  };
};

export const getMyAssignments = state =>
  state.feeny.assignments.all.map(id => getAssignment(state, id));

export const isAssignmentsFetching = state =>
  state.feeny.assignments.isFetching;

export const getMyAssignmentsCount = state =>
  state.feeny.assignments.all.length;

export const getUserReading = (state, id) => state.feeny.userReadings.byId[id];

export const getUserAssignment = (assignment, readingsById) => {
  return {
    ...assignment,
    readings: assignment.readings.map(id => readingsById[id])
  };
};

export const getUserAssignments = createSelector(
  state => state.feeny.userAssignments.all,
  state => state.feeny.userAssignments.byId,
  state => state.feeny.userReadings.byId,
  (all, byId, readingsById) =>
    all.map(id => getUserAssignment(byId[id], readingsById))
);

const compare = (assignmentA, assignmentB) => {
  if (!assignmentA.archived && assignmentB.archived) {
    return -1;
  }
  if (assignmentA.archived && !assignmentB.archived) {
    return 1;
  }
  return 0;
};

export const getUserAssignmentsByIsbn = (state, isbn) =>
  getUserAssignments(state).filter(({ vbid }) => vbid === isbn);

export const getSortedUserAssignmentsByIsbn = (state, isbn) => {
  // Returns getUserAssignmentsByIsbn
  // but with archived assignments at end of array
  const assignments = getUserAssignments(state).filter(
    ({ vbid }) => vbid === isbn
  );
  return assignments.sort(compare);
};

export const getUniqueVbidsforAllAssignments = state => {
  return getUserAssignments(state).reduce(
    (acc, x) => acc.concat(acc.find(obj => obj.vbid === x.vbid) ? [] : [x]),
    []
  );
};

export const getAssignmentsByIsbn = (state, isbn) =>
  getMyAssignments(state).filter(({ vbid }) => vbid === isbn);

export const getUserAssignmentsCount = state => {
  return state.feeny.userAssignments.all.length;
};

export const getUserAssignmentsIsbns = createSelector(
  getUserAssignments,
  userAssignments => [
    ...new Set(
      userAssignments.map(assignment => {
        return assignment.vbid;
      })
    )
  ]
);

// TODO Do we need a selector for Assignments.url?
